import EmberPowerSelectOptions from 'ember-power-select/components/power-select/options';

export default class BvSelectOptions extends EmberPowerSelectOptions {}
